import './App.css';
import NavMenu from "./NavMenu";
import {useEffect, useState, useCallback} from 'react';
import {Routes, Route} from 'react-router-dom';
import EcsCluster from "./EcsCluster";
import {EcsContext} from './contexts/EcsContext';
import {GitHubContext} from "./contexts/GitHubContext";
import {S3Context} from './contexts/S3Context';
import {authenticatedFetch} from "./authenticatedFetch";
import ProtectedRoute from './ProtectedRoute';
import Changelog from "./Changelog";
import keycloak from "./keycloak";
import config from "./config";
import S3Websites from "./S3Websites";
import Home from "./Home";
import Lambdas from "./Lambdas";

function AppContent() {
    const [ecsClusters, setClusterData] = useState(null);
    const [ecsServices, setServiceData] = useState(null);
    const [githubRepos, setGithubReposData] = useState(null);
    const [s3Websites, setS3WebsitesData] = useState(null);

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            const urls = [
                '/config/ecs/clusters',
                '/config/ecs/services',
                '/config/github/repos',
                '/config/s3/websites',
            ];

            const [clusterConfigData, serviceData, githubRepoData, s3WebsitesData] = await Promise.all(
                urls.map(url => authenticatedFetch(config.apiUrl + url).then(res => res.json()))
            );

            setClusterData(clusterConfigData);
            setServiceData(serviceData);
            setGithubReposData(githubRepoData);
            setS3WebsitesData(s3WebsitesData);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const logout = () => {
        if (keycloak) {
            keycloak.logout({redirectUri: window.location.origin});
        }
    };

    if (isLoading) return <div>Loading app data...</div>;
    if (error) return <div>Error: {error.message}</div>;

    return (
        <EcsContext.Provider value={{ecsClusters, ecsServices}}>
            <GitHubContext.Provider value={{githubRepos}}>
                <S3Context.Provider value={{s3Websites}}>
                    <div>
                        <NavMenu username={keycloak.tokenParsed.preferred_username}
                                 onLogout={logout}
                        />
                        <Routes>
                            <Route element={<ProtectedRoute/>}>
                                <Route path="/" element={<Home/>}/>
                                <Route
                                    path="/app-services"
                                    element={
                                        <div>
                                            <EcsCluster cluster="monitapp-cluster"/>
                                            <S3Websites/>
                                            <Lambdas/>
                                        </div>
                                    }
                                />
                                <Route path="/sso-services" element={<EcsCluster cluster="monitsso-cluster"/>}/>
                                <Route path="/changelog" element={<Changelog/>}/>
                            </Route>
                        </Routes>
                    </div>
                </S3Context.Provider>
            </GitHubContext.Provider>
        </EcsContext.Provider>
    );
}

function App() {
    return (
        <AppContent/>
    );
}

export default App;

